import { LEAD_FORM_API } from "./env";

const formItemsToNumber = ["Price", "Beds", "Baths"];

const leadMutation = {
	query:
		"mutation postDesignCenterLeadForm($content: DesignCenterLeadForm!, $leadFormId: String) { postDesignCenterLeadForm(content: $content, leadFormId: $leadFormId) }",
	variables: {
		content: {},
		leadFormId: "",
	},
};

export type leadFormData = Record<string, unknown> & {
	MarketingMeta: Record<string, unknown>;
};

export function submitLeadForm(leadFormId: string, formData: leadFormData) {
	formItemsToNumber.forEach((key) => {
		if (formData[key]) {
			formData[key] = Number(formData[key]);
		}
	});

	leadMutation.variables.leadFormId = leadFormId;
	leadMutation.variables.content = formData;

	return fetch(LEAD_FORM_API, {
		method: "post",
		body: JSON.stringify(leadMutation),
		headers: {
			"Content-Type": "application/json",
		},
	}).then((response) =>
		response.ok ? response.json() : Promise.reject("Bad Request"),
	);
}
